import { connect } from 'react-redux';

import PdpColorwayUpdatesFormModal from 'components/PdpColorwayUpdatesFormModal';
import * as actions from 'state/actions';
import { getCurrentProduct, colorwayUpdatesFormModalIsOpen } from 'state/selectors/pdp';

const mapStateToProps = state => {
  const isOpen = colorwayUpdatesFormModalIsOpen(state);
  const currentProduct = getCurrentProduct(state);

  return {
    isOpen,
    currentProduct,
  };
};

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(actions.closeModal()),
  onSubmit: params => dispatch(actions.signUpForNewsletter(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PdpColorwayUpdatesFormModal);
